import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGridView = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 23,
	height: 21,
	viewBox: "0 0 23 21",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			x: 1.6,
			y: 1.6,
			width: 7.8,
			height: 6.8,
			rx: 1.4,
			stroke: "black",
			strokeWidth: 1.2
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 1.6,
			y: 11.6,
			width: 7.8,
			height: 6.8,
			rx: 1.4,
			stroke: "black",
			strokeWidth: 1.2
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 13.6,
			y: 11.6,
			width: 7.8,
			height: 6.8,
			rx: 1.4,
			stroke: "black",
			strokeWidth: 1.2
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 13.6,
			y: 1.6,
			width: 7.8,
			height: 6.8,
			rx: 1.4,
			stroke: "black",
			strokeWidth: 1.2
		})
	]
});
export default SvgGridView;
